module.exports = __webpack_public_path__ + "aa0319286f84f987920577e80cb7bdeb.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/812.png
// module id = 1715
// module chunks = 2